import {HttpClient} from '../http-client';
import Season from '../seasons/season';
import Team from './team';

class TeamApi extends HttpClient {
  public constructor() {
    super(process.env.VUE_APP_API_URL)
  }

  public getTeams = async (leagueId: number): Promise<Team[]> => {
    const response = await this.instance.get(`teams/${leagueId}/`);
    const teams: Team[] = response.data.teams;
    return teams;
  };

  public getMatchups = async (leagueId: number): Promise<Season> => {
    const response = await this.instance.get(`teams/matchups/${leagueId}/`);
    const matchups = response.data;
    return matchups;
  }

  public getLeagueHistory = async (leagueId: number): Promise<Season[]> => {
    const response = await this.instance.get(`league/${leagueId}/history/`);
    const history = response.data;
    return history;
  }

  public getNflGames = async () => {
    const response = await this.instance.get(`nfl-games/`);
    const games = response.data;
    return games;    
  }
}

export const teamApi = new TeamApi();